/* Barnacle Zone — theme behaviour */
(function () {
  'use strict';

  /* Scroll reveal

     A .reveal wrapper is the whole page body on most templates, so anything
     that stops this running leaves the visitor looking at a blank page. Two
     defects caused exactly that, and both are fixed here.

     1. threshold 0.12 asked for 12% of the ELEMENT to be visible. An element
        taller than about eight screens can never satisfy that - the ratio is
        capped by viewport height over element height - so long articles and
        the Vault sat invisible until a scroll happened to nudge the ratio
        over the line, if it ever did. Any overlap at all is the right test
        for a full-page wrapper, so the threshold is now 0.

     2. Nothing revealed what was already on screen at load. The observer is
        asynchronous and, on iOS in particular, its first callback can wait
        for the next paint or scroll. Anything in view is now shown
        synchronously before the observer is even attached, so the first
        frame is never empty.

     The load and pageshow handlers are the backstop. pageshow catches the
     back button, where a page restored from the browser cache would
     otherwise keep whatever state it was frozen in. Both only reveal what is
     actually in view, so sections further down still get their fade. */

  function revealNode(n) { n.classList.add('in'); }

  function isInView(n) {
    var r = n.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.top < h && r.bottom > 0 && r.width > 0;
  }

  function revealVisible() {
    var hidden = document.querySelectorAll('.reveal:not(.in)');
    Array.prototype.forEach.call(hidden, function (n) {
      if (isInView(n)) revealNode(n);
    });
  }

  function initReveal() {
    var nodes = document.querySelectorAll('.reveal:not(.in)');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, revealNode);
      return;
    }

    revealVisible();

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { revealNode(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

    Array.prototype.forEach.call(nodes, function (n) {
      if (!n.classList.contains('in')) io.observe(n);
    });

    if (!window.__bzRevealBackstop) {
      window.__bzRevealBackstop = true;
      window.addEventListener('load', revealVisible);
      window.addEventListener('pageshow', revealVisible);
    }
  }

  /* Mobile nav */
  function initNav() {
    var btn = document.querySelector('[data-menu-toggle]');
    var panel = document.querySelector('[data-mobile-nav]');
    if (!btn || !panel || btn.dataset.navBound === 'true') return;
    btn.dataset.navBound = 'true';
    btn.addEventListener('click', function () {
      var open = panel.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Product gallery thumbs */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.dataset.full;
          main.srcset = '';
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* Variant + purchase-option (one-time vs subscription) selection.
     Shopify owns the subscription contract; this only keeps the
     displayed price and the renewal disclosure in step with the choice. */
  function initVariants() {
    document.querySelectorAll('[data-variant-form]').forEach(function (form) {
      var json = form.querySelector('[data-variant-json]');
      if (!json) return;
      var data = {};
      try { data = JSON.parse(json.textContent); } catch (e) { return; }

      var select = form.querySelector('[data-variant-select]');
      var scope = form.closest('.product-info') || document;
      var priceEl = scope.querySelector('[data-price]');
      var submit = form.querySelector('[data-submit]');
      var planRadios = form.querySelectorAll('[data-plan-radio]');
      var terms = form.querySelector('[data-subscription-terms]');

      function currentVariantId() {
        if (select) return select.value;
        var hidden = form.querySelector('input[name="id"]');
        return hidden ? hidden.value : Object.keys(data)[0];
      }
      function currentPlanId() {
        var checked = form.querySelector('[data-plan-radio]:checked');
        return checked ? checked.value : '';
      }

      function render() {
        var v = data[currentVariantId()];
        if (!v) return;
        var planId = currentPlanId();
        var price = (planId && v.plans && v.plans[planId]) ? v.plans[planId] : v.price;
        if (priceEl) priceEl.innerHTML = price;
        if (terms) terms.hidden = !planId;
        if (submit) {
          submit.disabled = !v.available;
          submit.textContent = v.available ? submit.dataset.labelAdd : submit.dataset.labelSold;
        }
      }

      if (select) select.addEventListener('change', render);
      planRadios.forEach(function (r) { r.addEventListener('change', render); });
      if (planRadios.length) render();
    });
  }

  /* Masthead fit.
     Every label in the bar is nowrap, so the bar can never break a
     word across two lines. If the inline nav genuinely will not fit
     at the current width it collapses into the hamburger instead.
     This is measured rather than guessed at a fixed pixel width, so
     it stays correct when the menu gains an item or when the
     webfonts finish loading and change the measurements. */
  function fitHeader() {
    var bar = document.querySelector('.topbar-inner');
    if (!bar) return;
    var header = bar.parentNode;
    var nav = bar.querySelector('nav.primary');
    if (!header || !nav) return;
    header.classList.remove('nav-collapsed');
    if (window.getComputedStyle(nav).display === 'none') return;
    if (bar.scrollWidth > bar.clientWidth + 1) header.classList.add('nav-collapsed');
  }

  function initHeaderFit() {
    fitHeader();
    if (initHeaderFit.bound) return;
    initHeaderFit.bound = true;

    var queued = false;
    window.addEventListener('resize', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; fitHeader(); });
    });

    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(fitHeader).catch(function () {});
    }
  }

  /* Copy link.
     navigator.clipboard needs a secure context; the textarea fallback
     covers anything older, so the button never silently does nothing. */
  function initCopyLink() {
    document.querySelectorAll('[data-copy-link]').forEach(function (btn) {
      if (btn.dataset.copyBound === 'true') return;
      btn.dataset.copyBound = 'true';

      btn.addEventListener('click', function () {
        var url = btn.dataset.copyLink;
        var label = btn.querySelector('[data-copy-text]');
        var original = label ? label.textContent : '';

        function done() {
          btn.classList.add('is-copied');
          if (label) label.textContent = btn.dataset.done || 'Copied';
          window.setTimeout(function () {
            btn.classList.remove('is-copied');
            if (label) label.textContent = original;
          }, 2200);
        }

        function fallback() {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); done(); } catch (e) { /* no-op */ }
          document.body.removeChild(ta);
        }

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).then(done).catch(fallback);
        } else {
          fallback();
        }
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () { initReveal(); initNav(); initHeaderFit(); initGallery(); initVariants(); initCopyLink(); });

  /* Re-run inside the theme editor */
  document.addEventListener('shopify:section:load', function () {
    initReveal(); initNav(); initHeaderFit(); initGallery(); initVariants(); initCopyLink();
  });
})();
